import {useMemo} from 'react';
import {GeoDataItem} from '@/map/@types';
import {SHAPE_COLOR_OPTIONS} from '@/map/constants';
import {AreaOverlayType} from '@/map/enums';
import {convertToPolygonPathsFromGeometry} from '@/map/utils';
import {palette} from '@/styles';
import {PolygonCenterTextMarker} from '../Markers';
import {PolygonArea} from '../Overlay';

interface IProps {
  map: naver.maps.Map;
  item: GeoDataItem;
  colorOptions?: {
    fillColor?: string;
    fillOpacity?: number;
    strokeColor?: string;
    color?: string;
    strokeWeight?: number;
  };
  displayNameTag?: boolean;
  highlightName?: boolean;
}

const DEFAULT_COLOR_OPTIONS: IProps['colorOptions'] = {
  ...SHAPE_COLOR_OPTIONS[AreaOverlayType.EMD],
  color: palette.white,
  fillOpacity: 0.5,
  strokeWeight: 2,
};

export const EmdArea = ({
  map,
  item,
  colorOptions = DEFAULT_COLOR_OPTIONS,
  displayNameTag,
  highlightName,
}: IProps) => {
  const polygons = useMemo<naver.maps.ArrayOfCoords[]>(() => {
    if (item?.geometry?.coordinates?.length) {
      return convertToPolygonPathsFromGeometry(item?.geometry?.coordinates);
    }

    return [];
  }, [item?.geometry]);

  return (
    <>
      {displayNameTag && !!item && !!item.geometry && (
        <PolygonCenterTextMarker
          map={map}
          text={item.emd}
          geometry={item.geometry}
          highlight={highlightName}
          markerColor={colorOptions.strokeColor}
          textColor={colorOptions.color}
        />
      )}
      {polygons?.map((paths: any, idx: number) => (
        <PolygonArea
          key={idx}
          map={map}
          paths={paths}
          colorOptions={colorOptions}
          hiddenVertexMarker
        />
      ))}
    </>
  );
};
